import React from "react";

import { FolderIcon } from "@common/folderIcon";
import { Checkbox } from "../../../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Project({ project, isSelected, select, unSelect }: Props) {
  return (
    <div className={styles.project} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <FolderIcon className={styles.icon} />
      <p className={styles.name}>{project.name}</p>
    </div>
  );
}

export { Project };
